"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostCallFrame = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const video_frame_mobile_1 = require("../video_frame/video_frame_mobile");
const controls_1 = require("../../lobby/controls");
const room_session_1 = require("../../../context/room_session");
const company_settings_1 = require("../../../context/company_settings");
const successful_streemshot_1 = require("../successful_streemshot");
const __1 = require("../../..");
const sdk_core_1 = require("@streem/sdk-core");
const gps_response_1 = require("./gps_response/gps_response");
const request_camera_flip_1 = require("./request_camera_flip");
const company_info_1 = require("../../../context/company_info");
const expert_avatar_1 = require("./expert_avatar");
const device_troubleshooting_modal_1 = require("../../device_troubleshooting/device_troubleshooting_modal");
const take_first_emitted_1 = require("../../../util/take_first_emitted");
const use_host_video_track_restart_listener_1 = require("../../../hooks/use_host_video_track_restart_listener");
const lost_connection_modal_1 = __importDefault(require("../../lobby/lost_connection_modal"));
const ending_call_screen_1 = require("./ending_call_screen");
function HostCallFrame({ onCallEndedByHost = () => { } }) {
    const roomSession = (0, room_session_1.useRoomSession)();
    const companyInfo = (0, company_info_1.useCompanyInfo)();
    const companySettings = (0, company_settings_1.useCompanySettings)();
    const [roomInvitationStatus] = (0, __1.useObservable)(roomSession.roomInvitationStatus);
    const [hostAudioConnected] = (0, __1.useObservable)(roomSession.media.localAudio.connected);
    const [localVideoController] = (0, __1.useObservable)(roomSession.media.localVideoController);
    const [audioState] = (0, __1.useObservable)(roomSession.media.localAudio.enabled);
    const [videoState = false] = (0, __1.useVideoEnabled)(roomSession.media.localVideoController);
    const [videoControllers] = (0, __1.useObservable)(roomSession.media.videoControllers);
    const [hasRemoteUserConnection] = (0, __1.useObservable)(roomSession.media.hasRemoteUserConnection);
    const [trackProviderConnectionState] = (0, __1.useObservable)(roomSession.media.connectionState);
    const [remoteParticipantStatus] = (0, __1.useObservable)(roomSession.room.remoteParticipantStatus);
    const [roomSessionStatus] = (0, __1.useObservable)(roomSession.status);
    const [callStartTime] = (0, __1.useObservable)(roomSession.bookmarks.callStartTime);
    const [userMediaVideoError] = (0, __1.useObservable)(roomSession.media.getUserMediaVideoError);
    const [userMediaAudioError] = (0, __1.useObservable)(roomSession.media.getUserMediaAudioError);
    const [cameraFlipOpen, setCameraFlipOpen] = (0, react_1.useState)(false);
    const [leavingCall, setLeavingCall] = (0, react_1.useState)(false);
    const [showLostConnectionMessage, setShowLostConnectionMessage] = (0, react_1.useState)(false);
    const [deviceTroubleshootingModalConfig, setDeviceTroubleshootingModalConfig] = (0, react_1.useState)({ deviceType: 'Microphone', showDeviceTroubleshootingModal: false });
    (0, react_1.useEffect)(() => {
        if (userMediaAudioError === 'NotAllowedError') {
            setDeviceTroubleshootingModalConfig({
                deviceType: 'Microphone',
                showDeviceTroubleshootingModal: true,
            });
        }
        else if (userMediaVideoError === 'NotAllowedError') {
            setDeviceTroubleshootingModalConfig({
                deviceType: 'Camera',
                showDeviceTroubleshootingModal: true,
            });
        }
    }, [userMediaAudioError, userMediaVideoError]);
    (0, react_1.useEffect)(() => {
        if (!callStartTime)
            return;
        const lostConnectionTimeoutId = setTimeout(() => {
            setShowLostConnectionMessage(true);
        }, 1000);
        return () => clearTimeout(lostConnectionTimeoutId);
    }, [callStartTime]);
    const handleEndCallByHost = () => {
        setLeavingCall(true);
        onCallEndedByHost();
    };
    (0, use_host_video_track_restart_listener_1.useHostVideoTrackRestartListener)(roomSession);
    if (!(0, sdk_core_1.isRoomSession)(roomSession)) {
        throw new sdk_core_1.StreemError('Unable to provide in-call experience without a RoomSession.');
    }
    const videoFrames = (0, react_1.useMemo)(() => {
        if (!videoControllers || !videoControllers.length) {
            return undefined;
        }
        return videoControllers.map(controller => {
            // right now, all the host is always on mobile... so VideoFrameMobile is fine.
            return (0, jsx_runtime_1.jsx)(video_frame_mobile_1.VideoFrameMobile, { videoController: controller }, controller.id);
        });
    }, [videoControllers]);
    (0, react_1.useEffect)(() => {
        const setBackgrounded = (backgrounded) => __awaiter(this, void 0, void 0, function* () {
            const localVideo = yield (0, take_first_emitted_1.takeFirstEmitted)(roomSession.media.localVideoController);
            yield (localVideo === null || localVideo === void 0 ? void 0 : localVideo.setBackgrounded(backgrounded));
            // Note: this sets localAudio to backgrounded, but the mic may or may not be available when the
            //       browser tab is backgrounded.  This code should check to see if the mic is available
            //       before setting it to backgrounded, but I'm not sure if that's possible.
            roomSession.media.localAudio.setBackgrounded(backgrounded);
        });
        const checkIfBackgrounded = () => {
            if (document.visibilityState === 'visible') {
                setBackgrounded(false);
            }
            else {
                setBackgrounded(true);
            }
        };
        document.addEventListener('visibilitychange', checkIfBackgrounded);
        return () => {
            window.removeEventListener('visibilityChange', checkIfBackgrounded);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // For 2 way video, wait for the spectator video track to be available.  For 1 way video,
    //    the spectator video track is not displayed
    const waitingForSpectatorVideo = (companySettings === null || companySettings === void 0 ? void 0 : companySettings.faceToFaceModeEnabled) &&
        !(videoControllers === null || videoControllers === void 0 ? void 0 : videoControllers.some(controller => !controller.ownerIsLocalUser));
    // Consider the spectator present if:
    //    1. The room invitation has been accepted
    //    2. We are not waiting for the spectator video to connect
    //    3. There is at least one remote user connected
    //    4. The remote user is active
    const spectatorInCall = roomInvitationStatus === 'ACCEPTED' &&
        !waitingForSpectatorVideo &&
        hasRemoteUserConnection &&
        remoteParticipantStatus === streem_sdk_protobuf_1.streem.api.RoomParticipant.Status.STATUS_ACTIVE;
    const callEndingOrEnded = roomSessionStatus === 'DISCONNECTING' ||
        roomSessionStatus === 'DISCONNECTED' ||
        leavingCall;
    const isReconnectingToTrackProvider = trackProviderConnectionState === 'RECONNECTING';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showLostConnectionMessage &&
                roomSessionStatus === 'CONNECTED' &&
                isReconnectingToTrackProvider &&
                !leavingCall && (0, jsx_runtime_1.jsx)(lost_connection_modal_1.default, {}), deviceTroubleshootingModalConfig.showDeviceTroubleshootingModal && ((0, jsx_runtime_1.jsx)(device_troubleshooting_modal_1.DeviceTroubleshootingModal, { permissionDenied: userMediaAudioError === 'NotAllowedError' ||
                    userMediaVideoError === 'NotAllowedError', handleContinue: () => setDeviceTroubleshootingModalConfig({
                    deviceType: 'Microphone',
                    showDeviceTroubleshootingModal: false,
                }), inCall: true, device: deviceTroubleshootingModalConfig.deviceType })), (0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(Top, Object.assign({ className: 'fade-in' }, { children: (companySettings === null || companySettings === void 0 ? void 0 : companySettings.watermarkUrl) ? ((0, jsx_runtime_1.jsx)(ui_react_1.CompanyWatermark, { src: companySettings.watermarkUrl, onError: event => (event.target.style.display = 'none') })) : ((0, jsx_runtime_1.jsx)(ui_react_1.StreemWatermark, {})) })), (0, jsx_runtime_1.jsx)(request_camera_flip_1.RequestCameraFlip, { open: cameraFlipOpen, setOpen: setCameraFlipOpen }), (0, jsx_runtime_1.jsx)(gps_response_1.GpsResponse, {}), !spectatorInCall && !callEndingOrEnded && ((0, jsx_runtime_1.jsx)(expert_avatar_1.ExpertAvatar, { className: 'fade-in', companyInfo: companyInfo })), callEndingOrEnded && !hasRemoteUserConnection && (0, jsx_runtime_1.jsx)(ending_call_screen_1.EndingCallScreen, {}), (0, jsx_runtime_1.jsx)(successful_streemshot_1.SuccessfulStreemshot, {}), spectatorInCall && videoFrames, (0, jsx_runtime_1.jsxs)(Bottom, Object.assign({ className: 'fade-in' }, { children: [!cameraFlipOpen && ((0, jsx_runtime_1.jsx)(controls_1.Controls, { inCall: true, onEndCallButtonClicked: handleEndCallByHost, audioState: {
                                    notAvailable: !hostAudioConnected ||
                                        (!spectatorInCall && roomSession.isUsingTwilioAndIOS18),
                                    showMicTroubleshootingMessage: () => {
                                        setDeviceTroubleshootingModalConfig({
                                            deviceType: 'Microphone',
                                            showDeviceTroubleshootingModal: true,
                                        });
                                    },
                                    enabled: audioState !== null && audioState !== void 0 ? audioState : false,
                                    toggleEnabled: () => {
                                        roomSession.media.localAudio.setEnabled(!audioState);
                                    },
                                }, videoState: {
                                    enabled: videoState !== null && videoState !== void 0 ? videoState : false,
                                    toggleEnabled: () => {
                                        if (localVideoController) {
                                            localVideoController.setEnabled(!videoState);
                                        }
                                    },
                                } })), (0, jsx_runtime_1.jsx)(ButtonGradient, {})] }))] })] }));
}
exports.HostCallFrame = HostCallFrame;
const Top = ui_react_1.styled.div({
    position: 'absolute',
    top: '5vh',
    display: 'flex',
    width: '100vw',
    justifyContent: 'center',
    zIndex: 3,
});
const Bottom = ui_react_1.styled.div `
    position: absolute;
    bottom: 15px;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    @media (orientation: landscape) {
        position: fixed;
        bottom: 5px;
    }
`;
const Container = ui_react_1.styled.div(({ theme }) => `
    width: 100%;
    background-color: ${theme.colors.black};
    display: flex;

    @keyframes fadeInAnimation {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .fade-in {
        animation: fadeInAnimation ease 2s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
    }

    z-index: ${theme.layers.callFrame}
`);
const ButtonGradient = ui_react_1.styled.div `
    background: linear-gradient(
        0deg,
        hsla(0, 0%, 0%, 0.6) 0%,
        hsla(0, 0%, 0%, 0.021) 91%,
        hsla(0, 0%, 0%, 0.008) 95.2%,
        hsla(0, 0%, 0%, 0.002) 98.2%,
        hsla(0, 0%, 0%, 0) 100%
    );
    mix-blend-mode: multiply;
    width: 100%;
    height: 140px;
    position: fixed;
    bottom: 0;
    z-index: 0;
`;
//# sourceMappingURL=host_call_frame.js.map